import constants from '../constants';

const initState = () => ({
  didUnsubscribeAllSucceed: true,
});

const marketing = (state = initState(), action = {}) => {
  const { type, payload } = action;

  if (type === constants.SET_UNSUBSCRIBE_ALL_SUCCESS) {
    return { ...state, didUnsubscribeAllSucceed: payload };
  } else if (type === constants.SET_UNSUBSCRIBE_RESULT) {
    return { ...state, unsubscribeResult: payload };
  }
  return state;
};

export default marketing;
